import { ICostSummaryItem, ILineItem } from '../../CartContext.types';

export const useBundleDiscountHook = (lineItem: ILineItem): ICostSummaryItem | undefined => {
    if (lineItem.promoSummary?.hasBundleDiscount) {
        const item: ICostSummaryItem = {
            lineNumber: lineItem.lineNumber,
            itemName: lineItem.promoSummary.bundleDiscountPromo.name,
            amount: lineItem.promoSummary.dueMonthly,
            type: 'discount'
        };

        return item;
    }
};
